import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    width: 100%;
    color: #0b0c0c;
    font-family: source-sans-pro, sans-serif;

  }

  * {
  font-family: source-sans-pro, sans-serif;
  
  font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  .container {
    width: 60%;
    margin: auto;
    margin-top: 61px;
  }

  .termsOfUse {
    margin-top: 100px;
    padding-bottom: 20px;
    color: #1565C0;
    display: flex;
    justify-content: center;
  }

  p {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        font-family: source-sans-pro, sans-serif;

    }
   
  h1, h2, h3, h4, h5, h6 {
    font-family: source-sans-pro, sans-serif;
  }  

  a,
    p > a {
        color: #1565c0;

        font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
        :hover {
            :hover {
                text-decoration: none;
            }
        }
    }
`;
